export default __webpack_public_path__ + "static/media/fireFN30.80e9365e.svg";